<template>
    <div id='files-root'>
        <div id='section-body' class="row">
            <div class="col l6 files" style="padding: 2.5em;">
                <div class="row flex" style='margin-bottom:0;'>
                    <span style="font-weight:bold;font-size:1.4em;vertical-align:middle;">Files</span>
                    <input @change="upload" id="uploadfile" accept=".stl" type="file"/>
                    <button @click="selectUploadFile()" class="a3d btn small upload">
                        Upload new file
                    </button>
                    <button class="a3d btn small create-nested"
                            v-if="files.length > 0"
                            @click="toggleNestedMode()">
                        {{nestedMode ? 'Cancel' : 'Create'}} nested job
                    </button>
                </div>
                <div v-if="deleting || uploading" class="progress">
                  <div class="indeterminate">
                  </div>
                </div>
                <div v-show='message' class="error">
                    {{ message }}
                </div>
                <div v-if="files.length < 1 && !filesPagination.loading" class="no-files center-align">
                    There are no files yet
                </div>
                <div class="a3d file" v-for="(file, index) in files" :key="file.pathKey">
                    <div style="margin-right:1em;">
                        <i class="material-icons a3d color"
                           style="cursor:pointer;"
                           v-if="!nestedMode"
                           @click="deleteF(file)">
                           clear
                        </i>
                        <input type="checkbox"
                               :id="file.pathKey"
                               class="filled-in"
                               :checked="filesNested[file.pathKey]"
                               @change="setNestedFile(file)"
                               v-if="nestedMode"/>
                        <label :for="file.pathKey"></label>
                    </div>
                    <div class="file-name-nested">
                        {{ file.name }}
                    </div>
                    <div v-if="file.isVirus" class="file-error">
                      File is infected
                    </div>
                    <div v-else class="button-block right">
                        <div v-if="file.isInvalidStlFile" class="file-error">
                          File is corrupted
                        </div>
                        <button class="a3d btn small inv"
                                v-if="(!file.fixOperation || file.fixOperation.status === 'DRAFT' || file.fixOperation.status === 'SUBMITTED') && !user.isGovcloudUser && !file.isInvalidStlFile"
                                :disabled="repairProcess[file.id]"
                                @click="fileRepairOpen(file)">
                          {{repairProcess[file.id] ? 'Repairing...' : 'Repair File'}}
                        </button>
                        <a class="a3d btn small inv"
                           @click="fileDownload({
                                     filename: file.name,
                                     sourceFilePathKey: file.pathKey
                                   })">Download</a>
                        <router-link :to="{ name: 'CreateJob', params: { id: file.id } }" class="a3d btn small" v-if="!file.isInvalidStlFile">
                            Create job
                        </router-link>
                    </div>
                    <div class="progress" v-if="repairProcess[file.id]">
                        <div class="indeterminate" v-if="true">
                        </div>
                    </div>
                </div>
                <div v-if="deleting || filesPagination.loading" class="progress">
                    <div class="indeterminate">
                    </div>
                </div>
                <div class="center-align" v-if="!filesPagination.isAllLoaded && filesFormatted.length > 0 && !filesPagination.loading">
                    <button class="a3d btn load-files"
                            :disabled="filesPagination.loading || uploading || deleting"
                            @click.prevent="loadSourceFiles()">Load more</button>
                    <!-- <ul class="pagination">
                        <li :class="{'active': (page - 1) === filesPagination.currentPage}" v-for="page in pagesList" :key="page">
                            <template v-if="page">
                                <a v-if="(page - 1) === filesPagination.currentPage">{{ page }}</a>
                                <a href="#" @click.prevent="switchFilesPage(page)" v-else>{{ page }}</a>
                            </template>
                            <div class="skip" v-else>...</div>
                        </li>
                    </ul> -->
                </div>
                <div class="center-align" v-if="nestedMode && Object.keys(filesNested).length > 0">
                    <button class="a3d btn" @click="nestParts()">Nest selected parts</button>
                </div>
            </div>
            <div class="col l6 jobs a3d" style="padding: 2.5em;">
                <div class="row">
                    <div>
                        <span style="font-weight:bold;font-size:1.4em;vertical-align:middle;">Jobs</span>
                    </div>
                    <div class="progress" v-if="loadingJobs">
                        <div class="indeterminate" v-if="!jobsProgress.loaded">
                        </div>
                        <div class="determinate" v-else :style="'width: ' + (jobsProgress.loaded / jobsProgress.total)*100 + '%'">
                        </div>
                    </div>
                    <div v-else>
                        <div class="right-align" v-if="filesFormatted.length > 0">
                            <button
                              v-if="compareMode && (Object.keys(filesCompare).length > 0 || Object.keys(nestedFilesCompare).length > 0)"
                              class="a3d btn"
                              @click="showEstimateModal()"
                            >
                                Compare
                              </button>
                            <button class="a3d btn inv" @click="toggleCompareMode()">{{compareMode ? 'Cancel comparing' : 'Compare Print Costs'}}</button>
                            <a href="#" v-if="!showArchived && countArchivedJobs > 0" class="a3d btn inv" @click.prevent="toggleArchived">View Archived Jobs</a>
                            <a href="#" v-if="showArchived && countActiveJobs > 0" class="a3d btn inv" @click.prevent="toggleArchived">View Active Jobs</a>
                        </div>
                        <div class="a3d file job" v-if="showArchived && countArchivedJobs < 1">
                            <div class="message center-align">
                                There are no archived jobs yet
                            </div>
                        </div>
                        <div class="a3d file job" v-if="!showArchived && countActiveJobs < 1">
                            <div class="message center-align">
                                There are no created jobs yet
                            </div>
                        </div>
                        <div v-for="(file, index) in filesFormatted" :key="file.jobId ? file.jobId : file.id">
                            <template v-if="file.isNested">
                                <job-output :job="file" v-if="file.isArchived === showArchived" :compare-mode="compareMode"></job-output>
                            </template>
                            <template v-else>
                                <file-output :file="file" :show-archived="showArchived" :compare-mode="compareMode"></file-output>
                            </template>
                        </div>
                        <div v-if="jobsPagination.loading" class="progress">
                            <div class="indeterminate">
                            </div>
                        </div>
                    </div>
                    <div style="flex-grow:1;padding-top:3px;">
                        <modal ref="removemodal" name="removemodal" :pivotY="0.2" :reset="true" height="auto" width="300px" @before-open="removeJobOpen">
                            <div class="prompt-modal">
                                <div class="title">Are you sure that you want to delete this job?</div>
                                <div class="row">
                                    <div class="col s6 right-align">
                                        <button class="a3d btn" @click="removeJob()">Yes</button>
                                    </div>
                                    <div class="col s6 left-align">
                                        <button class="a3d btn inv" @click="removeJobConfirmationCancel()">No</button>
                                    </div>
                                </div>
                            </div>
                        </modal>
                        <modal ref="repairmodal" name="repairmodal" :pivotY="0.2" :reset="true" height="auto" width="400px" @closed="fileRepairClose">
                            <div class="prompt-modal">
                                <div class="modal-content">
                                  <div class="repair-form">
                                    <div class="block-input-wrp">
                                      <div class="block-input">
                                        <div class="block-description">
                                          Mesh envelope size
                                        </div>
                                        <div class="block-value">
                                          <input type="text"
                                                id="tetraEpsField"
                                                v-model="repairConfig.tetraEps.current"
                                                @change="verifyNumPositive(repairConfig.tetraEps)"
                                                class="validate">
                                        </div>
                                      </div>
                                      <div class="block-note">Small envelope size improves accuracy but increases run time</div>
                                      <h6 class="error" v-if="repairConfig.tetraEps.invalid">Please input a valid size.</h6>
                                    </div>
                                    <div class="block-input-wrp">
                                      <div class="block-input">
                                        <div class="block-description">
                                          Tetra mesh size
                                        </div>
                                        <div class="block-value">
                                          <input type="text"
                                                id="tetraMeshSizeField"
                                                v-model="repairConfig.tetraMeshSize.current"
                                                @change="verifyNumPositive(repairConfig.tetraMeshSize)"
                                                class="validate">
                                          <div class="unit">mm</div>
                                        </div>
                                      </div>
                                      <h6 class="error" v-if="repairConfig.tetraMeshSize.invalid">Please input a valid size.</h6>
                                    </div>
                                  </div>
                                  <div>
                                    Please review your geometry carefully once the repair is complete. Repairing STL
                                    files may create unwanted changes to discreet features.
                                  </div>
                                </div>
                                <div class="row">
                                    <div class="col s6 right-align">
                                        <button class="a3d btn" @click="fileRepair()">Repair File</button>
                                    </div>
                                    <div class="col s6 left-align">
                                        <button class="a3d btn inv" @click="fileRepairClose()">Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </modal>
                        <modal ref="resubmitjobmodal" name="resubmitjobmodal" :pivotY="0.2" :reset="true" height="auto" width="400px" @before-open="resubmitJobOpen">
                            <div class="prompt-modal">
                                <div class="modal-content">
                                    Are you sure that you want to re-submit job?
                                </div>
                                <div class="row">
                                    <div class="col s6 right-align">
                                        <button class="a3d btn" @click="resubmitJob()">Submit</button>
                                    </div>
                                    <div class="col s6 left-align">
                                        <button class="a3d btn inv" @click="resubmitJobClose()">Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </modal>
                    </div>
                    <estimate-cost/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import { mapState, mapActions, mapGetters } from 'vuex'
  import errorHandling from '../mixins/errorHandling'
  import JobOutput from './Files/JobOutput.vue'
  import FileOutput from './Files/FileOutput.vue'
  import EstimateCost from './EstimateCost.vue'
  import { defaultConfig } from '../services/helpers'

  export default {
    components: {
      JobOutput,
      FileOutput,
      EstimateCost
    },
    name: 'files',
    props: ['showModal'],
    mixins: [errorHandling],
    data: function () {
      return {
        selectedCredits: 1,
        uploading: false,
        message: '',
        deleting: false,
        loadingJobs: false,
        jobsToggle: [],
        jobsToggleLoading: [],
        showArchived: false,
        jobArchiving: false,
        jobToRemove: null,
        fileToRepair: null,
        jobToResubmit: null,
        nestedMode: false,
        compareMode: false,
        repairProcess: {},
        repairConfig: {
          tetraEps: {last: '', current: defaultConfig.tetraEps[0], invalid: false},
          tetraMeshSize: {last: '', current: defaultConfig.tetraMeshSize[0], invalid: false}
        }
      }
    },
    computed: {
      ...mapState([
        'user',
        'gettingFileURL',
        'files',
        'jobs',
        'filesPagination',
        'jobsPagination',
        'jobsProgress',
        'filesNested',
        'filesCompare',
        'nestedFilesCompare'
      ]),
      ...mapGetters([
        'filesFormatted'
      ]),
      ...mapGetters({
        subscription: 'user/subscriptionExpiration'
      }),
      // pagesList () {
      //   const totalPages = Math.ceil(this.filesPagination.totalFiles / this.filesPagination.filesOnPage)
      //   let pagesList = []
      //   let currentPage = this.filesPagination.currentPage + 1
      //   for (let i = 1; i <= totalPages; i++) {
      //     if (totalPages > 8) {
      //       if (
      //         i === 1 ||
      //         i === totalPages ||
      //         i === (currentPage - 1) ||
      //         i === (currentPage - 2) ||
      //         i === currentPage ||
      //         i === (currentPage + 1) ||
      //         i === (currentPage + 2) ||
      //         (currentPage === 1 && (i === 4)) ||
      //         (currentPage === totalPages && (i === totalPages - 3))
      //       ) {
      //         pagesList.push(i)
      //       } else {
      //         if (pagesList[pagesList.length - 1]) {
      //           pagesList.push(false)
      //         }
      //       }
      //     } else {
      //       pagesList.push(i)
      //     }
      //   }
      //   return pagesList
      // },
      countActiveJobs () {
        let count = 0
        this.filesFormatted.forEach((file) => {
          if (file.unarchived) {
            count += file.unarchived
          } else if (file.isNested && !file.isArchived) {
            count += 1
          }
        })
        return count
      },
      countArchivedJobs () {
        let count = 0
        this.filesFormatted.forEach((file) => {
          if (file.archived) {
            count += file.archived
          } else if (file.isNested && file.isArchived) {
            count += 1
          }
        })
        return count
      }
    },
    methods: {
      ...mapActions({
        refreshCredits: 'user/refreshCredits'
      }),
      ...mapActions([
        'uploadFile',
        'checkSourceFile',
        'refreshFiles',
        'loadSourceFile',
        'repairFile',
        'getJobsOrdered',
        'getJobOutputs',
        'deleteFile',
        'getDownloadURL',
        'getURLData',
        'clearUpdateTimers',
        'setNestedFile',
        'resetCompareFiles',
        'getJob',
        'createJob',
        'submitJob',
        'updateJob',
        '_jobs/archiveJob'
      ]),
      init: function () {
        this.loadingJobs = true
        this.$store.commit('RESET_NESTED_DATA')
        const isResetFiles = this.files.length < this.filesPagination.filesOnPage && !this.filesPagination.isAllLoaded ? 'resetFiles' : null
        const isNotFirstInit = this.files.length ? 'notFirstInit' : null
        const rule = isResetFiles || isNotFirstInit
        this.refreshFiles(rule)
          .then(() => {
            return this.getJobsOrdered()
          })
          .then(() => {
            // for (var i = 0; i < this.jobsFormatted.length; i++) { // for each job=
            //   for (var j = 0; j < this.jobsFormatted[i].jobOutputs.length; j++) { // for each jobOutput
            //     if (!this.jobsFormatted[i].jobOutputs[j].paidfor) { continue }
            //     for (var k = 0; k < this.jobsFormatted[i].jobOutputs[j].outputFiles.length; k++) { // for each outputFile
            //       this.refreshOutputUrl({
            //         jobOutputPathKey: this.jobsFormatted[i].jobOutputs[j].jobOutputPathKey,
            //         jobPathKey: this.jobsFormatted[i].jobPathKey,
            //         sourceFilePathKey: this.jobsFormatted[i].sourceFilePathKey,
            //         filename: this.jobsFormatted[i].jobOutputs[j].outputFiles[k].name
            //       })
            //     }
            //   }
            // }
            this.loadingJobs = false
          })
          .catch((err) => {
            this.loadingJobs = false
            this.errorHandling(err, this.init)
          })
      },
      buymodal: function () {
        this.$modal.show('details')
      },
      // switchFilesPage (page) {   // split files to pages
      //   this.refreshFiles(page - 1)
      //     .then()
      //     .catch((err) => {
      //       this.errorHandling(err, () => {
      //         this.switchFilesPage(page)
      //       })
      //     })
      // },
      loadSourceFiles () {
        return this.refreshFiles()
      },
      loadJobs () {
        this.getJobsOrdered()
      },
      removeJobOpen (event) {
        this.jobToRemove = {
          element: event.params.element,
          sourceFilePathKey: event.params.sourceFilePathKey,
          pathKey: event.params.pathKey
        }
      },
      removeJobConfirmationCancel () {
        this.jobToRemove = null
        this.$modal.hide('removemodal')
      },
      removeJob () {
        this.jobToRemove.element.target.innerHTML = 'Removing...'
        this.jobToRemove.element.target.disabled = true
        this.$modal.hide('removemodal')
        this.$store.dispatch('_jobs/deleteJob', this.jobToRemove.pathKey)
          .then(response => {
            this.$store.commit('REMOVE_JOB', {
              sourceFilePathKey: this.jobToRemove.sourceFilePathKey,
              pathKey: this.jobToRemove.pathKey
            })
            this.jobToRemove.element.target.innerHTML = 'Remove'
            this.jobToRemove.element.target.disabled = false
            this.jobToRemove = null
          })
          .catch((err) => {
            this.errorHandling(err, this.removeJob)
            this.jobToRemove.element.target.innerHTML = 'Remove'
            this.jobToRemove.element.target.disabled = false
          })
      },
      toggleArchived () {
        this.jobsToggle = []
        this.showArchived = !this.showArchived
      },
      fileRepairOpen (file) {
        this.fileToRepair = file
        this.$modal.show('repairmodal')
      },
      fileRepairClose () {
        this.fileToRepair = null
        this.$modal.hide('repairmodal')
      },
      fileRepair () {
        const file = this.fileToRepair
        this.$modal.hide('repairmodal')
        this.$set(this.repairProcess, file.id, true)

        file.config = {
          tetraEps: Number(this.repairConfig.tetraEps.current),
          tetraMeshSize: Number(this.repairConfig.tetraMeshSize.current)
        }

        this.repairFile(file)
          .then((response) => {
            this.repairFileGetData(file, response.data.progress, 1)
          })
          .catch((err) => {
            this.errorHandling(err, () => this.repairFile(file))
            this.$set(this.repairProcess, file.id, false)
          })
      },
      repairFileGetData (file, url, attempt) {
        this.getURLData({url})
          .then((optimizerResponse) => {
            if (optimizerResponse.data && optimizerResponse.data.result) {
              this.loadSourceFile({ id: file.id, forceRefresh: true })
                .then(() => {
                  this.$set(this.repairProcess, file.id, false)
                })
            } else {
              this.$set(this.repairProcess, file.id, false)
              throw new Error('Repair failed')
            }
          })
          .catch((err) => {
            if (err.response &&
              err.response.status &&
              err.response.status === 404 && attempt <= 40) {
              attempt++
              let delay = 5000 * attempt
              if (attempt > 3) {
                delay = 15000
              }
              setTimeout(() => {
                this.repairFileGetData(file, url, attempt)
              }, delay)
            } else if (err.message === 'Repair failed') {
              this.$set(this.repairProcess, file.id, false)
              this.errorHandling(err, () => {
                this.fileToRepair = file
                this.fileRepair()
              })
            } else {
              this.errorHandling(err, () => this.repairFileGetData(file.id, url, attempt))
              this.$set(this.repairProcess, file.id, false)
              throw new Error('Get repair result failed')
            }
          })
      },
      resubmitJobOpen ({params}) {
        this.jobToResubmit = {
          element: params.element,
          sourceFilePathKey: params.sourceFilePathKey,
          config: {...params.jobConfig, filename: params.filename},
          jobPathKey: params.jobPathKey,
          jobDescription: params.jobDescription,
          analysisId: params.jobAnalysisId,
          objectiveId: params.jobObjectiveId
        }
      },
      resubmitJobClose () {
        this.jobToResubmit = null
        this.$modal.hide('resubmitjobmodal')
      },
      resubmitJob () {
        let jobPathKey
        const getAdditionalData = () => {
          if (this.jobToResubmit.config.AdditionalConfig) {
            return this.getDownloadURL({
              sourceFilePathKey: this.jobToResubmit.sourceFilePathKey,
              jobPathKey: this.jobToResubmit.jobPathKey,
              filename: 'additional_config.json'
            })
              .then((response) => {
                return this.getURLData({url: response.data.url})
              })
              .then((data) => {
                this.jobToResubmit.config = Object.assign(this.jobToResubmit.config, data.data)
                return Promise.resolve('Additional data merged to config')
              })
          } else {
            return Promise.resolve('Skip getting additional data')
          }
        }
        this.jobToResubmit.element.target.innerHTML = 'Submitting...'
        this.jobToResubmit.element.target.disabled = true
        this.$modal.hide('resubmitjobmodal')
        getAdditionalData()
        .then(() => {
          return this.createJob({
            sourceFilePathKey: this.jobToResubmit.sourceFilePathKey,
            config: this.jobToResubmit.config
          })
        })
        .then((response) => {
          jobPathKey = response.data.jobPathKey
          return this.updateJob({
            jobPathKey,
            config: this.jobToResubmit.config,
            jobDescription: this.jobToResubmit.jobDescription
          })
        })
        .then(() => {
          return this.submitJob({
            jobPathKey,
            analysisId: this.jobToResubmit.analysisId,
            objectiveId: this.jobToResubmit.objectiveId
          })
        })
        .then((response) => {
          return this.getJob(jobPathKey)
        })
        .then((response) => {
          this.jobToResubmit.element.target.innerHTML = 'Re-Submit'
          this.jobToResubmit.element.target.disabled = false
          this.jobToResubmit = null
        })
        .catch((err) => {
          console.log('error', err)
          this.errorHandling(err, this.resubmitJob)
          this.jobToResubmit.element.target.innerHTML = 'Re-Submit'
          this.jobToResubmit.element.target.disabled = false
        })
      },
      selectUploadFile: function () {
        document.getElementById('uploadfile').click()
      },
      fileDownload ({filename, sourceFilePathKey, jobPathKey, jobOutputPathKey, newTab}) {
        if (!this.gettingFileURL) {
          this.$store.commit('TOGGLE_GETTING_FILE_URL', true)
          this.getDownloadURL({filename, sourceFilePathKey, jobPathKey, jobOutputPathKey})
            .then((response) => {
              if (newTab) {
                Object.assign(document.createElement('a'), {target: '_blank', href: response.data.url}).click()
              } else {
                location.assign(response.data.url)
              }
              this.$store.commit('TOGGLE_GETTING_FILE_URL', false)
            })
            .catch((err) => {
              this.$store.commit('TOGGLE_GETTING_FILE_URL', false)
              this.errorHandling(err)
            })
        }
      },
      upload: function () {
        this.uploading = true
        if (document.getElementById('uploadfile').files[0].name.match(/.(stl)$/i)) {
          this.message = ''
          this.uploadFile({
            file: document.getElementById('uploadfile').files[0]
          })
            .then((response) => {
              const {pathKey} = response.config
              let timing = 25000
              let i = 0
              const waitForFile = () => setTimeout(() => {
                this.checkSourceFile({pathKey}).then((res) => {
                  if (res.length || i === 3) {
                    this.uploading = false
                    document.getElementById('uploadfile').value = null
                  } else {
                    i += 1
                    timing = 5000
                    waitForFile()
                  }
                })
              }, timing)
              waitForFile()
            })
            .catch((err) => {
              this.uploading = false
              this.errorHandling(err)
            })
        } else {
          this.message = 'Sorry, your file is an invalid file type. Please upload only STL files at this time.'
          this.uploading = false
        }
      },
      deleteF (file) {
        this.deleting = true
        this.deleteFile(file)
          .finally(res => {
            this.deleting = false
          })
      },
      toggleNestedMode () {
        this.nestedMode = !this.nestedMode
      },
      toggleCompareMode (evt) {
        this.resetCompareFiles()
        this.compareMode = !this.compareMode
      },
      showEstimateModal () {
        this.$modal.show('estimate-cost', {isCompare: true})
      },
      nestParts () {
        this.$router.push({name: 'NestedQuantity'})
      },
      verifyNumPositive: function (sNum) {
        if (isNaN(sNum.current) || sNum.current === '' || sNum.current <= 0) {
          sNum.current = sNum.last
          sNum.invalid = true
          return false
        } else {
          sNum.last = sNum.current
          sNum.invalid = false
          return true
        }
      }
    },
    beforeCreate () {
      this.$store.dispatch('resetJobs')
    },
    created () {
      this.init()
    },
    beforeDestroy () {
      this.clearUpdateTimers()
    },
    filters: {
      dateFormat: function (value) {
        return new Date(value).toLocaleString({
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
    #uploadfile {
        display: none;
    }

    .files-preloader {
        padding: 128px;
    }

    .pagination {
        .active {
            background-color: $btn-color;
        }

        .skip {
            font-weight: bold;
            line-height: 30px;
        }
    }

    .a3d {
        &.file {
            position: relative;
            margin: 0.5em 0;
            padding: 1em;
            display: inline-flex;
            width: 100%;
            background-color: $bg-gray;
            align-items: center;
            .progress {
                position: absolute;
                bottom: 0px;
                left: 0px;
                margin-bottom: 0px;
            }
            .material-icons.a3d {
                display: flex;
            }
            .file-error {
              color: #ff0000;
              font-size: 14px;
              font-weight: bold;
              text-align: center;
            }
        }
        &.jobout {
            margin: 0.5em 0;
            padding: 1em;
            background-color: $bg-gray;
            width: 100%;
            align-items: center;
        }
        &.job-status {
            flex-direction: column;
            .job-status-message {
                align-self: flex-start;
            }
        }
        &.jobs {
            background-color: $bg-gray;
        }
        &.job {
            background-color: #FFFFFF;
            display: flex;
            .message {
                flex-grow: 1;
                padding: 1em 0;
            }
        }
        &.align-right {
            justify-content: flex-end;
        }
        .toggleIcon {
            padding-left: 16px;
            cursor: pointer;
            align-self: center;
        }
        .jobout-buttons {
            padding-top:1px;
            margin-left:24px;
            display: flex;
            flex-direction: column;
            flex: 2;

            .jobout-buttons-row {
                display: flex;
                flex-direction: row-reverse;
                padding-bottom: 6px;
                .btn {
                    margin: auto 0 auto 6px;
                }
            }
        }
    }

    #files-root {
        height: 100%;
        margin-top: -64px;
        padding-top: 64px;
    }

    #section-body {
        height: 100%;
        margin-top: -120px;
        padding-top: 120px;
        margin-bottom: 0;
        > div {
            height: 100%;
        }

        .row {
            &.flex {
                display: flex;
                justify-content: flex-start;
            }
        }

        .files {
            .upload {
                padding: 0.5em 1em;
                margin-left: 1em;
            }

            .create-nested {
                margin-left: auto;
            }

            .error {
                padding: 0.5em 0 1em 0;
                color: #ff0000;
            }

            .no-files {
                padding: 1em;
            }

            .load-files {
              margin-bottom: 0.5em;
            }
        }

        .file {
            [type="checkbox"].filled-in + label {
                padding-left: 24px;
            }

            [type="checkbox"].filled-in:checked + label:after {
                border-color: #00BDD1;
                background-color: #00BDD1;
            }
        }

        .file-name-block {
            flex-grow: 1;
            display: flex;
            flex-direction: column;

            .file-name {
                word-break: break-all;
                flex-grow: 1;
                font-size:1.3em;
                font-weight:bold;
                padding-right: 4px;
            }

            .file-date {
                font-size: 14px;
            }
        }

        .file-name-nested {
            word-break: break-all;
            flex: 2;
            display: flex;
            align-items: center;
        }

        .button-block {
            display: flex;
            text-align: right;
            min-width: 120px;
            justify-content: flex-end;
            align-items: center;
            flex: 4;

            .btn {
                margin-left: 4px;

                i {
                    font-size: 0.9rem;
                }
            }

            .menu {
                .btn {
                    width: 100%;
                    margin-bottom: 0!important;
                }
            }
        }
    }

    .prompt-modal {
        padding: 20px;
        .row {
            margin-bottom: 0;
        }
        .title {
            font-size: 1.4em;
            text-align: center;
            padding-bottom: 20px;
        }
        .modal-content {
            padding-bottom: 12px;
        }
    }

    .repair-form {
      .block-input-wrp {
        margin-bottom: 20px;

        .block-input {
          display: flex;
          align-items: center;

          .block-description {
            margin-bottom: 2px;
            flex: 1;
          }
          .block-value {
            display: flex;
            flex-direction: row;
            padding-left: 10px;
            flex: 1;

            input {
              margin: 0;
            }

            .unit {
              padding-left: 10px;
              font-weight: bold;
              font-size: 22px;
            }
          }
        }
        .block-note {
          font-size: 12px;
          padding-top: 5px;
        }
        .error { 
          font-size: 12px;
          color: #ff0000;
        }
      }
    }

    @media (max-width: 1400px) {
        #section-body {
            .jobs {
                .jobfile {
                    .button-block {
                        flex-direction: column;

                        .btn {
                            margin-bottom: 4px;
                        }
                    }
                }
            }
        }
    }

    @media (max-width: 1200px) {
        #section-body {
            .files {
                .button-block {
                    flex-direction: column;
                    align-items: stretch;
                    flex: 1;
                    .btn {
                        margin-bottom: 4px;
                        &:last-child {
                            margin-bottom: 0px;
                        }
                    }
                }
            }
        }
    }

    @media (max-width: 992px) {
        #section-body {
            .files, .jobs {
                width: 100%;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// Files.vue?3536aaee